import React from "react";
import { useCart } from "react-use-cart";
import { Link } from "react-router-dom";
import { saveToLocalStorage } from "../../utils/localStorage";
import {
  Typography,
  Box,
  Container,
  CssBaseline,
  Card,
  Button,
  CardContent,
} from "@mui/material";
import { FaCartShopping } from "react-icons/fa6";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import Title from "../title";

export default function CartContents() {
  const {
    isEmpty,
    totalItems,
    items,
    cartTotal,
    emptyCart,
    updateItemQuantity,
    removeItem,
  } = useCart();

  if (isEmpty)
    return (
      <Box
        sx={{
          height: "80vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="body1" color="text.secondary" noWrap>
          The cart is empty
        </Typography>
      </Box>
    );
  return (
    <>
      <CssBaseline />
      <Container maxWidth="sm">
        <Box sx={{ minheight: "90vh" }}>
          <Card
            sx={{
              backgroundColor: "#FBFAF8",
              maxWidth: 800,
              p: { md: 6, xs: 1 },
              m: { md: 5, xs: 1}
            }}
          >
            <Box sx={{  textAlign: 'center'}}>
              <Typography variant="overline" color="text.secondary" noWrap>
              <FaCartShopping size={12} /> The cart
            </Typography>
            </Box>
            

            {items.map((item, index) => {
              return (
                <div key={index} className="itemCart">
                  <CardContent>
                    <Link to={`/products/${item.id}`}>
                      <Title val={item.title} />
                    </Link>
                    <Typography variant="button" noWrap>
                      {item.discountedPrice} nok
                    </Typography>
                  </CardContent>
                  <CardContent>
                    <Box sx={{ display: 'flex', flexDirection: 'row'}}>
                       <Button
                      color="secondary"
                      variant="outlined"
                      onClick={() =>
                        updateItemQuantity(item.id, item.quantity - 1)
                      }
                    >
                      <FaCircleMinus size={20} />
                    </Button>
                    <Typography sx={{ typography: { md:"overline", xs:"caption"  }, p: 2 }} noWrap>
                      Quantity: {item.quantity}
                    </Typography>
                    <Button
                      color="secondary"
                      variant="outlined"
                      onClick={() =>
                        updateItemQuantity(item.id, item.quantity + 1)
                      }
                    >
                      <FaCirclePlus size={20} />
                    </Button>
                    </Box>
                   
                  </CardContent>
                  <CardContent>
                    <Button
                      color="secondary"
                      variant="outlined"
                      onClick={() => removeItem(item.id)}
                    >
                      Remove
                    </Button>
                  </CardContent>
                </div>
              );
            })}
            <CardContent>
              {" "}
              <div>
                <Typography variant="overline" noWrap>
                  Total Items: {totalItems}
                </Typography>
              </div>
              <div>
                <Typography variant="button" noWrap>
                  Total: {cartTotal.toFixed(2)} nok
                </Typography>
              </div>
            </CardContent>
            <CardContent>
              <Link to={`/checkout`}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    saveToLocalStorage("productItems", items);
                    saveToLocalStorage("productTotalPrice", cartTotal);
                    emptyCart();
                  }}
                >
                  Checkout
                </Button>
              </Link>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </>
  );
}
